export default {
  setLocale (lang: 'zh-TW' | 'en') {
    if (window.zE !== undefined) {
      // https://support.zendesk.com/hc/en-us/articles/203761906
      window.zE('webWidget', 'setLocale', lang.includes('zh-TW') ? 'zh-tw' : 'en-us')
    }
  }
}
